module.exports = __webpack_public_path__ + "img/1.2d9b2008.png";